(function () {
  if (window.alarmikoCountrySelectorReady) return;
  window.alarmikoCountrySelectorReady = true;
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('.alarmiko-country-form')) return;
    var returnInput = form.querySelector('input[name="return_to"]');
    if (!returnInput) return;
    var target = new URL(returnInput.value, window.location.origin);
    var current = new URL(window.location.href);
    current.searchParams.forEach(function (value, key) {
      if (/^utm_/i.test(key) || ['fbclid', 'gclid', 'msclkid', 'ttclid', 'variant'].includes(key)) {
        target.searchParams.set(key, value);
      }
    });
    target.hash = current.hash;
    returnInput.value = target.pathname + target.search + target.hash;
  });
  document.addEventListener('click', function (event) {
    document.querySelectorAll('.alarmiko-country-selector[open]').forEach(function (details) {
      if (!details.contains(event.target)) details.open = false;
    });
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.alarmiko-country-selector[open]').forEach(function (details) {
      details.open = false;
      details.querySelector('summary').focus();
    });
  });
})();

// Keep checkout return visits in the selected language and product view.
(async function alarmikoCartReturn() {
  if (!/^(?:\/(?:de|fr|nl|cs))?\/cart\/?$/.test(location.pathname) || window.Shopify?.designMode) return;
  const views={de:['alarmiko-camper'],fr:['alarmiko-fr','co-melder-maison','co-melder-bateau'],nl:['co-melder-camper','co-melder-huis','co-melder-boot'],cs:['detektor-co-dum']};
  let context=null;
  try { context=JSON.parse(sessionStorage.getItem('alarmiko-return-v1')); } catch (_) {}
  try {
    const response=await fetch('/cart.js',{headers:{'Accept':'application/json'},cache:'no-store'});
    if(response.ok) {
      const cart=await response.json(), attrs=cart.attributes || {};
      if(views[attrs._alarmiko_locale]) context={language:attrs._alarmiko_locale,view:attrs._alarmiko_view,url:attrs._alarmiko_return_url};
    }
  } catch (_) {}
  if(!context || !views[context.language]) return;
  const language=context.language;
  const view=views[language].includes(context.view) ? context.view : views[language][0];
  const productPath=(language==='de'?'':'/'+language)+'/products/'+(language==='fr'?'detecteur-co-gaz-camping-car':'alarmiko-co-gas');
  const productUrl=new URL(productPath,location.origin);
  productUrl.searchParams.set('view',view);
  productUrl.searchParams.set('country',({de:'DE',fr:'FR',nl:'NL',cs:'CZ'})[language]);
  context={language,view,url:productUrl.pathname+productUrl.search};
  try { sessionStorage.setItem('alarmiko-return-v1',JSON.stringify(context)); } catch (_) {}
  const destination=new URL(location.href);
  destination.pathname=(language==='de'?'':'/'+language)+'/cart';
  if(language==='nl') destination.searchParams.set('view','co-melder-camper');
  else if(language==='cs') destination.searchParams.set('view','detektor-co-dum');
  else destination.searchParams.delete('view');
  if(destination.searchParams.has('locale')) destination.searchParams.set('locale',language);
  if(destination.pathname!==location.pathname || destination.searchParams.get('view')!==new URL(location.href).searchParams.get('view')) {
    location.replace(destination.href);
    return;
  }
  const main=document.getElementById('MainContent') || document.querySelector('main');
  if(!main) return;
  main.querySelectorAll('a[href]').forEach(link=>{
    const href=new URL(link.href,location.origin);
    if(href.origin===location.origin && /\/products\/(?:alarmiko-co-gas|detecteur-co-gaz-camping-car)\/?$/.test(href.pathname)) { link.href=context.url; if(link.closest('h2,h3') && language==='fr') link.textContent='Alarmiko — Détecteur CO et gaz 4-en-1 '+({ 'alarmiko-fr':'pour camping-car','co-melder-maison':'pour la maison','co-melder-bateau':'pour bateau' })[view]; }
  });
  window.addEventListener('click',event=>{
    const link=event.target.closest?.('a[href]');
    if(!link || !main.contains(link) || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const href=new URL(link.href,location.origin);
    if(href.origin!==location.origin || !/\/products\/(?:alarmiko-co-gas|detecteur-co-gaz-camping-car)\/?$/.test(href.pathname)) return;
    event.preventDefault();event.stopImmediatePropagation();location.assign(context.url);
  },true);
  main.querySelectorAll('form').forEach(form=>{
    const action=new URL(form.action,location.origin);
    if(action.origin!==location.origin || !/\/cart(?:\/update)?\/?$/.test(action.pathname)) return;
    const locale=form.querySelector('input[name="locale"]');
    if(locale) locale.value=language;
    form.addEventListener('submit',event=>{
      let input=form.querySelector('input[name="return_to"]');
      if(!input) {input=document.createElement('input');input.type='hidden';input.name='return_to';form.appendChild(input);}
      input.value=event.submitter?.name==='checkout' ? '/checkout?locale='+language : destination.pathname+destination.search;
    },true);
  });
})();
